export const environment = {
	production: true,
	public_key_recaptcha: '6Lfx29EUAAAAAHq-9kv5WaObm6Ifxexu-U-YWNL8',
	domain: 'http://localhost:4200',
	key_google_maps: 'AIzaSyAOl8GnuiXTb2BrRanWZLw7wfSDBMKjUAc',
	url_server_backend: 'https://api-package-hub.vivipost.com',
	url_server_socket:'https://package-hub-realtime.vivipost.com',
	envName: 'prod',
	token_chatbot: '78795514-10f0-474f-9ac4-8ff47e4ac7af',
	stripePublicKey: 'pk_live_51He4DYLgXqRicYzDspK7DHbSIlpBnKhRkWd2QV3oueX3IetWGEvU79BspgaeMlql5KiQE4gyx18XRg7NviLNZCt500eNzrVUIZ'
};
